// Utility per la gestione delle date "solo giorno" (YYYY-MM-DD).
//
// IMPORTANTE: non usare mai Date.prototype.toISOString() per ricavare la data
// di un appuntamento. toISOString() converte in UTC e, per i fusi a est di
// Greenwich (Italia = UTC+1/+2), può riportare un oggetto Date al giorno
// precedente quando l'orario locale è vicino alla mezzanotte. Questo causava
// lo "slittamento" degli appuntamenti a un giorno diverso da quello scelto.
//
// formatDateLocal usa i componenti locali del calendario, coerenti con la
// vista mensile dell'admin, eliminando l'off-by-one.

export const formatDateLocal = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// Chiave deterministica di uno slot, usata come ID documento per garantire
// l'unicità (un solo appuntamento pubblico per coppia data+ora).
export const slotKey = (dateString, time) => `${dateString}_${time.replace(':', '-')}`;
